export const SEND_CHECK_TEXT = 'Отправить на проверку';
export const CLOSE_FORM_TEXT = 'Закрыть';



// WEBPACK FOOTER //
// ./src/pages/profile/components/info/compopnents/block/components/itemsblock/consts.ts